module.exports = __webpack_public_path__ + "images/change-services-af893bbc161a79f73dbe3c62f89517ba.svg";